<template>
  <v-container fluid>
    <v-row align="center" justify="center" style="height: 77vh;">
      <div>
        <div class="d-flex justify-center">
          <v-img class="mb-7" contain
                 max-height="70px" position="center center"
                 src="https://hub.swiset.com/wp-content/uploads/2021/03/Trading-Livestream-Swiset.png"/>
        </div>
        <h1 class="text-center">{{ $t('title_ClubRooms') }}</h1>
        <p class="text-center mt-2">{{ $t('description_ClubRooms') }}</p>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ClubRooms"
}
</script>



<style scoped>

</style>
